module.exports = __webpack_public_path__ + "images/65be301104cb5503064b1f681b22cdf8-caro3.jpg";